import { firebaseRef } from 'config'

export const BOOKMAKERLISTS_CHANGED = 'BOOKMAKERLISTS_CHANGED'
export const EDIT_LIST = 'EDIT_LIST'

export function bookmakerListsChanged(lists) {
  return {
    type: BOOKMAKERLISTS_CHANGED,
    lists
  }
}

export function editList(id, list) {
  if (Object.keys(list.bookmakers).length === 0)
    return deleteList(id)
  return ((dispatch, getState) => {
    window.analytics.track('Changed bookmaker list')
    firebaseRef.child('bookmakerLists').child(getState().auth.user.id).child(id).update(list)
  })
}

export function deleteList(id) {
  return ((dispatch, getState) => {
    window.analytics.track('Deleted bookmaker list')
    firebaseRef.child('bookmakerLists').child(getState().auth.user.id).child(id).set({})
  })
}

export function addList() {
  return ((dispatch, getState) => {
    let ref = firebaseRef.child('bookmakerLists').child(getState().auth.user.id).push()
    ref.set({
      bookmakers: {118: true},
      name: 'New list'
    })
    window.analytics.track('Added bookmaker list')
  })
}



/** WEBPACK FOOTER **
 ** ./src/actions/bookmakerLists.js
 **/